import { Injectable } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { AppConstants } from '../app.constants';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private formBuilder: FormBuilder, private utilsService: UtilsService) { }

  getLoginForm(): FormGroup {
    let form = this.formBuilder.group({
      usuario: ['', [Validators.required]],
      contrasena: ['', [Validators.required]],
    });
    return form;
  }

  getVerifyAccessForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      usuario: [this.utilsService.getObjeto(data.usuario, ''), [Validators.required]],
      contrasena: [this.utilsService.getObjeto(data.contrasena, ''), [Validators.required]],
      contrasenaEfimera: [this.utilsService.getObjeto(data.contrasenaEfimera, ''), [Validators.required]],
      codigoVerificacion: ['', [Validators.required]]
    });
    return form;
  }

  getInactivityForm(inactivityMinutes): FormGroup {
    let form = this.formBuilder.group({
      firstLevelTimer: [inactivityMinutes, Validators.required]
    });
    return form;
  }

  getPerfilForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      id: [this.utilsService.getObjeto(data.id, 0), [Validators.required]],
      username: [this.utilsService.getObjeto(data.username, ''), [Validators.required]],
      name: [this.utilsService.getObjeto(data.name, ''), [Validators.required]],
      lastname: [this.utilsService.getObjeto(data.lastname, ''), [Validators.required]],
      motherlastname: [this.utilsService.getObjeto(data.motherlastname, ''), [Validators.required]],
      phone: [this.utilsService.getObjeto(data.phone, ''), [Validators.required]],
    });
    form.controls.username.disable();
    return form;
  }

  getContraseniaModalForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      usuario: [this.utilsService.getObjeto(data.usuario, ''), [Validators.required]],
      contrasena: [this.utilsService.getObjeto(data.contrasena, ''), [Validators.required]],
      codigoVerificacion: [this.utilsService.getObjeto(data.codigoVerificacion, ''), [Validators.required]],
      rol: [this.utilsService.getObjeto(data.rol, ''), [Validators.required]],
      contrasenaAnterior: [this.utilsService.getObjeto(data.contrasena, ''), [Validators.required]],
      contrasenaNueva: ['', [Validators.required]],
      contrasenaConfirmacion: ['', [Validators.required]],
    }, {
      validator: [
        ConfirmedValidator('contrasena', 'contrasenaAnterior'),
        DistinctValidator('contrasenaAnterior', 'contrasenaNueva'),
        ConfirmedValidator('contrasenaNueva', 'contrasenaConfirmacion'),
      ]
    });
    return form;
  }

  getRecuperarContraseniaModalForm(): FormGroup {
    let form = this.formBuilder.group({
      correoElectronico: ['', [Validators.required, Validators.email]],
    });
    return form;
  }

  getFiltrosTablaForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      person: [this.utilsService.getObjeto(data.person, undefined), [Validators.required]],
      documentType: [this.utilsService.getObjeto(data.documentType, undefined), []],
      month: [this.utilsService.getObjeto(data.month, undefined), []],
      startDate: [undefined, []],
      endDate: [undefined, []],
    });
    return form;
  }

  getGeneracionLlavesForm(data?, comboList?, usuario?, modo?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    modo = this.utilsService.validarObjeto(modo) ? modo : AppConstants.MODO_VISTA.NUEVO;
    let form = this.formBuilder.group({
      idLlavesCriptograficas: [this.utilsService.getObjeto(data.idLlavesCriptograficas, 0), [Validators.required]],
      longitud: new FormControl({ value: this.utilsService.getComboPorNombre(data.longitud, comboList, 0, undefined), disabled: modo === AppConstants.MODO_VISTA.VER }, [Validators.required]),
      llavePublica: [this.utilsService.getObjeto(data.llavePublica, ''), [Validators.required]],
      llavePrivada: [this.utilsService.getObjeto(data.llavePrivada, ''), [Validators.required]],
      usuario: usuario
    });
    return form;
  }

  getFragmentarLlaveForm(data?, usuario?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    let form = this.formBuilder.group({
      idLlavesCriptograficas: [this.utilsService.getObjeto(data.idLlavesCriptograficas, 0), [Validators.required]],
      longitud: [this.utilsService.getObjeto(data.longitud, ''), [Validators.required]],
      fragmentos: [4, [Validators.required, Validators.min(2), Validators.max(4)]],
      llavePrivada: [this.utilsService.getObjeto(data.llavePrivada, ''), [Validators.required]],
      usuario: usuario
    });
    return form;
  }

  getUnirFragmentosLlaveModalForm(data?, listaFragmentos?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    listaFragmentos = this.utilsService.validarObjeto(listaFragmentos) ? listaFragmentos : [];
    let formArray = this.formBuilder.array([]);
    listaFragmentos.map((item) => {
      formArray.push(this.formBuilder.group({
        posicion: [item.posicion, []],
        fragmento: [item.fragmento, []]
      }));
    });
    let form = this.formBuilder.group({
      idLlavesCriptograficas: [this.utilsService.getObjeto(data.idLlavesCriptograficas, 0), [Validators.required]],
      llavePrivada: [this.utilsService.getObjeto(data.llavePrivada, ''), [Validators.required]],
      fragmentos: [this.utilsService.getObjeto(data.fragmentos, 0), [Validators.required, Validators.min(2), Validators.max(4)]],
      items: formArray
    });
    return form;
  }

  getUsuarioModalForm(data?, comboList?, usuario?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    let form = this.formBuilder.group({
      idUsuario: [this.utilsService.getObjeto(data.idUsuario, 0), [Validators.required]],
      rol: [this.utilsService.getCombo(data.idRolSistema, comboList, 0, undefined), [Validators.required]],
      correo: [this.utilsService.getObjeto(data.correoElectronico, ''), [Validators.required, Validators.email]],
      usuario: usuario
    });
    return form;
  }

  getVotacionesFiltrosForm(data?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      titulo: [this.utilsService.getObjeto(data.titulo, ''), []],
      fechaInicio: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), []],
      fechaTermino: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), []],
      estatus: [this.utilsService.getCombo(data.estatus, comboList, 0, undefined), []],
    });
    return form;
  }

  getVotacionesModalForm(data?, usuario?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    let form = this.formBuilder.group({
      idVotacion: [this.utilsService.getObjeto(data.idVotacion, 0), [Validators.required]],
      tituloVotacion: [this.utilsService.getObjeto(data.tituloVotacion, ''), [Validators.required]],
      fechaInicio: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), [Validators.required]],
      fechaFin: [this.utilsService.getObjeto(data.fechaFin, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), [Validators.required]],
      horaInicio: [this.utilsService.getObjeto(data.fechaInicio, '00:00:00', false, true), [Validators.required]],
      horaFin: [this.utilsService.getObjeto(data.fechaFin, '23:59:59', false, true), [Validators.required]],
      descripcion: [this.utilsService.getObjeto(data.descripcion, ''), [Validators.required]],
      llavePublica: [this.utilsService.getObjeto(data.llavePublica, ''), [Validators.required]],
      hashVotacion: [this.utilsService.getObjeto(data.hashVotacion, '-'), []],
      hashBoleta: [this.utilsService.getObjeto(data.hashBoleta, '-'), []],
      hashVotantes: [this.utilsService.getObjeto(data.hashVotantes, '-'), []],
      usuario: usuario,
      estatusVotacion: [this.utilsService.getObjeto(data.estatusVotacion, undefined), []],
    });
    return form;
  }

  getVotacionesFullModalForm(data?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      id: [this.utilsService.getObjeto(data.id, 0), [Validators.required]],
      estatus: [this.utilsService.getCombo(data.estatus, comboList, 0, undefined), [Validators.required]],
      titulo: [this.utilsService.getObjeto(data.titulo, ''), [Validators.required]],
      fechaInicio: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), [Validators.required]],
      fechaTermino: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), [Validators.required]],
      descripcion: [this.utilsService.getObjeto(data.descripcion, ''), [Validators.required]],
      llavePublica: [this.utilsService.getObjeto(data.llavePublica, ''), [Validators.required]],
      email: [this.utilsService.getObjeto(data.email, ''), [Validators.required, Validators.email]],
      pregunta: [this.utilsService.getObjeto(data.pregunta, ''), [Validators.required]],
      permitirVotoNulo: [this.utilsService.getObjeto(data.permitirVotoNulo, true), [Validators.required]],
    });
    return form;
  }

  getVerDatosVotacionForm(data?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      idVotacion: [this.utilsService.getObjeto(data.idVotacion, 0), [Validators.required]],
      tituloVotacion: [this.utilsService.getObjeto(data.tituloVotacion, ''), [Validators.required]],
      estatusVotacion: [this.utilsService.getObjeto(data.estatusVotacion, {}), []],
      fechaInicio: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'dd/MM/yyyy HH:mm:ss')), [Validators.required]],
      fechaFin: [this.utilsService.getObjeto(data.fechaFin, this.utilsService.toDateFormat(new Date(), 'dd/MM/yyyy HH:mm:ss')), [Validators.required]],
      descripcion: [this.utilsService.getObjeto(data.descripcion, ''), [Validators.required]],
      llavePublica: [this.utilsService.getObjeto(data.llavePublica, ''), [Validators.required]],
      hashVotacion: [this.utilsService.getObjeto(data.hashVotacion, '-'), []],
      hashBoleta: [this.utilsService.getObjeto(data.hashBoleta, '-'), []],
      hashVotantes: [this.utilsService.getObjeto(data.hashVotantes, '-'), []],
      usuario: [this.utilsService.getObjeto(data.usuario, ''), [Validators.required]],
    });
    return form;
  }

  getVotanteModalForm(data?, usuario?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    let form = this.formBuilder.group({
      idVotante: [this.utilsService.getObjeto(data.idVotante, 0), [Validators.required]],
      correoElectronico: [this.utilsService.getObjeto(data.correoElectronico, ''), [Validators.required, Validators.email]],
      idVotacion: [this.utilsService.getObjeto(data.idVotacion, 0), [Validators.required]],
      usuario: usuario
    });
    return form;
  }

  getPreguntaModalForm(data?, comboList?, usuario?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    let form = this.formBuilder.group({
      idPregunta: [this.utilsService.getObjeto(data.idPregunta, 0), [Validators.required]],
      idVotacion: [this.utilsService.getObjeto(data.idVotacion, 0), [Validators.required]],
      pregunta: [this.utilsService.getObjeto(data.pregunta, ''), [Validators.required]],
      descripcion: [this.utilsService.getObjeto(data.descripcion, ''), [Validators.required]],
      opcionesMinimas: [this.utilsService.getComboPorNombre(data.opcionesMinimas, comboList, 0, undefined), [Validators.required]],
      opcionesMaximas: [this.utilsService.getComboPorNombre(data.opcionesMaximas, comboList, 1, undefined), [Validators.required]],
      votoNulo: [this.utilsService.getObjeto(this.utilsService.getBooleanFromNumber(data.votoNulo), true), [Validators.required]],
      usuario: usuario
    });
    return form;
  }

  getOpcionModalForm(data?, usuario?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    usuario = this.utilsService.validarString(usuario) ? usuario : '';
    let form = this.formBuilder.group({
      idOpcion: [this.utilsService.getObjeto(data.idOpcion, 0), [Validators.required]],
      idPregunta: [this.utilsService.getObjeto(data.idPregunta, 0), [Validators.required]],
      opcion: [this.utilsService.getObjeto(data.opcion, ''), [Validators.required]],
      descripcion: [this.utilsService.getObjeto(data.descripcion, ''), [Validators.required]],
      usuario: usuario
    });
    return form;
  }

  getEmitirVotoForm(data?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
    });
    return form;
  }

  getEmitirVotoPreguntaModalForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      id: [this.utilsService.getObjeto(data.id, 0), [Validators.required]],
      voto: [this.utilsService.getObjeto(data.voto, ''), [Validators.required]],
      numeroRastreo: [this.utilsService.getObjeto(data.numeroRastreo, ''), [Validators.required]],
    });
    return form;
  }

  getResultadosFiltrosForm(data?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      titulo: [this.utilsService.getObjeto(data.titulo, ''), []],
      fechaInicio: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), []],
      fechaTermino: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), []],
      estatus: [this.utilsService.getCombo(data.estatus, comboList, 0, undefined), []],
    });
    return form;
  }

  getObtenerResultadoModalForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      idVotacion: [this.utilsService.getObjeto(data.idVotacion, 0), [Validators.required]],
      tituloVotacion: [this.utilsService.getObjeto(data.tituloVotacion, '')],
      estatusVotacion: [this.utilsService.getObjeto(data.estatusVotacion, {}), []],
      fechaInicio: [this.utilsService.getObjeto(data.fechaInicio, this.utilsService.toDateFormat(new Date(), 'dd/MM/yyyy HH:mm:ss')), []],
      fechaFin: [this.utilsService.getObjeto(data.fechaFin, this.utilsService.toDateFormat(new Date(), 'dd/MM/yyyy HH:mm:ss')), []],
      descripcion: [this.utilsService.getObjeto(data.descripcion, ''), []],
      llavePublica: [this.utilsService.getObjeto(data.llavePublica, ''), []],
      llavePrivada: [this.utilsService.getObjeto(data.llavePrivada, ''), [Validators.required]],
      hashVotacion: [this.utilsService.getObjeto(data.hashVotacion, '-'), []],
      hashBoleta: [this.utilsService.getObjeto(data.hashBoleta, '-'), []],
      hashVotantes: [this.utilsService.getObjeto(data.hashVotantes, '-'), []],
      hashVotos: [this.utilsService.getObjeto(data.hashVotos, '-'), []],
      votosRecibidos: [this.utilsService.getObjeto(data.votosRecibidos, 0), []],
      usuario: [this.utilsService.getObjeto(data.usuario, ''), []]
    });
    return form;
  }

  getVerResultadosForm(data?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      numeroRastreo: ['', []],
      correoParticipante: ['', [Validators.email]],
    });
    return form;
  }

  getPersonaModalForm(data?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    let form = this.formBuilder.group({
      id: [this.utilsService.getObjeto(data.id, 0), [Validators.required]],
      name: [this.utilsService.getObjeto(data.name, ''), [Validators.required]],
      rfc: [this.utilsService.getObjeto(data.rfc, ''), [Validators.required]],
      personType: [this.utilsService.getCombo(data.personType, comboList, 0, undefined), [Validators.required]],
      email: [this.utilsService.getObjeto(data.email, ''), [Validators.required, Validators.email]],
      phone: [this.utilsService.getObjeto(data.phone, ''), [Validators.required]],
      enabled: [this.utilsService.getObjeto(data.enabled, false), [Validators.required]],
    });
    return form;
  }

  getCfdiXmlModalForm(data?, cfdi?, xmlFile?, pdfFile?, comboList?): FormGroup {
    data = this.utilsService.validarObjeto(data) ? data : {};
    cfdi = this.utilsService.validarObjeto(cfdi) ? cfdi : {};
    let xmlName = this.utilsService.validarObjeto(xmlFile) ? xmlFile.name : '';
    let pdfName = this.utilsService.validarObjeto(pdfFile) ? pdfFile.name : '';
    data.iva = 0;
    data.isrWithhold = 0;
    data.ivaWithhold = 0;
    if (this.utilsService.validarObjeto(cfdi.impuestos.traslados) && this.utilsService.validarObjeto(cfdi.impuestos.traslados.traslado)) {
      data.iva = cfdi.impuestos.traslados.traslado.filter(item => item.impuesto === AppConstants.TAX_CODES.IVA).reduce((sum, current) => sum + parseFloat(current.importe), 0);
    }
    if (this.utilsService.validarObjeto(cfdi.impuestos.retenciones) && this.utilsService.validarObjeto(cfdi.impuestos.retenciones.retencion)) {
      data.isrWithhold = cfdi.impuestos.retenciones.retencion.filter(item => item.impuesto === AppConstants.TAX_CODES.ISR).reduce((sum, current) => sum + parseFloat(current.importe), 0);
      data.ivaWithhold = cfdi.impuestos.retenciones.retencion.filter(item => item.impuesto === AppConstants.TAX_CODES.IVA).reduce((sum, current) => sum + parseFloat(current.importe), 0);
    }
    let form = this.formBuilder.group({
      id: [this.utilsService.getObjeto(data.id, 0), [Validators.required]],
      person: [this.utilsService.getCombo(data.person, comboList, 0, undefined), [Validators.required]],
      documentType: [this.utilsService.getCombo(data.documentType, comboList, 1, undefined), [Validators.required]],
      paymentMethod: [this.utilsService.getObjeto(data.paymentMethod, undefined), []],
      cfdiType: [this.utilsService.getObjeto(data.cfdiType, undefined), []],
      paymentForm: [this.utilsService.getObjeto(data.paymentForm, undefined), []],
      currency: [this.utilsService.getObjeto(data.currency, undefined), []],
      fiscalRegime: [this.utilsService.getObjeto(data.fiscalRegime, undefined), []],
      cfdiUse: [this.utilsService.getObjeto(data.cfdiUse, undefined), []],
      cfdiDate: [this.utilsService.getObjeto(cfdi.fecha, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), [Validators.required]],
      stampDate: [this.utilsService.getObjeto(cfdi.complemento.timbreFiscal.fechaTimbrado, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), []],
      folio: [this.utilsService.getObjeto(cfdi.folio, ''), []],
      serie: [this.utilsService.getObjeto(cfdi.serie, ''), []],
      sender: [this.utilsService.getObjeto(cfdi.emisor.nombre, ''), [Validators.required]],
      senderRfc: [this.utilsService.getObjeto(cfdi.emisor.rfc, ''), []],
      receiver: [this.utilsService.getObjeto(cfdi.receptor.nombre, ''), [Validators.required]],
      receiverRfc: [this.utilsService.getObjeto(cfdi.receptor.rfc, ''), []],
      uuid: [this.utilsService.getObjeto(cfdi.complemento.timbreFiscal.uuid, ''), []],
      subtotal: [this.utilsService.getObjeto(cfdi.subTotal, 0), [Validators.required]],
      discount: [this.utilsService.getObjeto(cfdi.descuento, 0), []],
      iva: [this.utilsService.getObjeto(data.iva, 0), []],
      isrWithhold: [this.utilsService.getObjeto(data.isrWithhold, 0), []],
      ivaWithhold: [this.utilsService.getObjeto(data.ivaWithhold, 0), []],
      total: [this.utilsService.getObjeto(cfdi.total, 0), [Validators.required]],
      month: [this.utilsService.getObjeto(data.month, ''), []],
      year: [this.utilsService.getObjeto(data.year, ''), []],
      creationDate: [this.utilsService.getObjeto(data.creationDate, this.utilsService.toDateFormat(new Date(), 'yyyy-MM-dd'), true), []],
      enabled: [this.utilsService.getObjeto(data.enabled, true), [Validators.required]],
      xml: [xmlFile, []],
      xmlName: [xmlName, []],
      pdf: [pdfFile, []],
      pdfName: [pdfName, []],
    });
    form.controls.cfdiDate.disable();
    form.controls.sender.disable();
    form.controls.receiver.disable();
    form.controls.serie.disable();
    form.controls.folio.disable();
    form.controls.uuid.disable();
    form.controls.subtotal.disable();
    form.controls.iva.disable();
    form.controls.isrWithhold.disable();
    form.controls.ivaWithhold.disable();
    form.controls.total.disable();
    form.controls.xmlName.disable();
    form.controls.pdfName.disable();
    return form;
  }
}

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}

export function DistinctValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.distinctValidator) {
      return;
    }
    if (control.value === matchingControl.value) {
      matchingControl.setErrors({ distinctValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}
